import {
  IconCalendarTime,
  IconChevronLeft,
  IconChevronRight,
  IconListDetails,
  IconPrinter,
  IconReload,
  IconSearch,
  IconCloudDownload,
  IconTrash,
  IconRefresh,
} from '@tabler/icons-react';
import React, { useEffect, useState, useRef, useCallback, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import DefaultItem from '../components/Admin/DefaultItem';
import { getAuthorizationHeader, http } from '../config/http';
import Layouts from '../layouts/Layouts';
import InputBarang from '../components/Admin/InputBarang';
import DetailItem from './Modal/DetailItem';
import { DateRange } from 'react-date-range';
import moment from 'moment';
import PrintBandrol from '../components/Admin/PrintBandrol';
import { DinamicTitle } from '../utils/DinamicTitle';
import EditItem from './Modal/EditItem';
import Input from '../components/Input';
import ConfirmationDeleteItem from '../components/Admin/ConfirmationDeleteItem';
import { toast } from 'react-toastify';
import usePage from './features/usePage';
import { IconTransferIn, IconBookDownload, IconTransferOut, IconX, IconEye, IconEyeOff, IconAdjustmentsHorizontal, IconChevronDown, IconTruckDelivery, IconBuildingStore } from '@tabler/icons-react';
import TransferBanyakBarang from '../components/Admin/PindahBarangBanyak';
import HapusBanyakBarang from '../components/Admin/HapusBanyakBarang';
import TransferBarangToCabang from '../components/Admin/TransferBarangToCabang';
import LoadingIndicator from '../components/LoadingIndicator';
import PindahBakiBanyak from '../components/Admin/PindahBakiBanyak';
import PinBrankas from '../components/Admin/PinBrankas';
import ModalBuatPengirimanCepat from '../components/Admin/ModalBuatPengirimanCepat';
import ModalTransferAntarToko from '../components/Admin/ModalTransferAntarToko';
import { useMasterData } from '../context/MasterDataContext';

function ListBrankas() {
  const navigate = useNavigate();

  const [isPinVerified, setIsPinVerified] = useState(
    sessionStorage.getItem('brankasPinVerified') === 'true'
  );

  const [items, setItems] = useState([]);
  // console.log('items::: ', items);
  const { kategoriList: kategori = [], cabangList: cabang = [], bakiList = [], karatList = [] } = useMasterData();
  const karatOption = karatList && karatList.length > 0 ? karatList : [16, 17, 18, 19, 20, 21, 22, 23, 24];
  const bakiOption = bakiList && bakiList.length > 0 ? bakiList : Array.from({ length: 20 }, (_, i) => i + 1);
  const [page_filter, setPageFilter] = useState([]);

  const [selectedKategori, setSelectedKategori] = useState('');
  const [selectedBaki, setSelectedBaki] = useState([]);
  const [isOpenBaki, setIsOpenBaki] = useState(false);
  const bakiDropdownRef = useRef(null);
  const [selectJenisKategori, setSelectJenisKategori] = useState('');
  const [totalModal, setTotalModal] = useState(0);
  const [jmlBarang, setJmlBarang] = useState(0);
  const [jmlBerat, setJmlBerat] = useState(0);

  const [isSubmitItem, setIsSubmitItem] = useState(false);

  const [detailItem, setDetailItem] = useState([]);
  // console.log('detailItem::: ', detailItem);
  const [openLoading, setOpenLoading] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  //   const [openCalender, setOpenCalender] = useState(false);

  let [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageInput, setPageInput] = useState('1');
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectStatus, setSelectStatus] = useState('');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  const [openPrintBandrol, setOpenPrintBandrol] = useState(false);
  const [openPindahBanyakBarang, setOpenPindahBanyakBarang] = useState(false);
  const [openHapusBanyakBarang, setOpenHapusBanyakBarang] = useState(false);
  const [openPindahBanyakBaki, setOpenPindahBanyakBaki] = useState(false);
  const [showSelectedPreview, setShowSelectedPreview] = useState(false);
  const [totalModalFilter, setTotalModalFilter] = useState(0);
  const [isEdit, setIsEdit] = useState(false);

  const [deleteId, setDeleteId] = useState('');
  const [barangDelete, setBarangDelete] = useState([]);
  const [loadingDel, setLoadingDel] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [selectedKarat, setSelectedKarat] = useState([]);
  
  const handleSelectKarat = (karat) => {
    const karatStr = String(karat);
    if (selectedKarat.includes(karatStr) || selectedKarat.includes(karat)) {
      setSelectedKarat(selectedKarat.filter((k) => String(k) !== karatStr));
    } else {
      setSelectedKarat([...selectedKarat, karatStr]);
    }
    setCurrentPage(1);
  };

  const handleSelectBaki = (baki) => {
    const bakiStr = String(baki);
    if (selectedBaki.includes(bakiStr) || selectedBaki.includes(baki)) {
      setSelectedBaki(selectedBaki.filter((b) => String(b) !== bakiStr));
    } else {
      setSelectedBaki([...selectedBaki, bakiStr]);
    }
    setCurrentPage(1);
  };
  // const [page_filter_loop, setPageFilterLoop] = useState([]);
  const [filterBerat, setFilterBerat] = useState('');

  const [berat, setBerat] = useState('');

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const filterBeratBarang = () => {
    setBerat(filterBerat);
  };

  const activeFilters = React.useMemo(() => {
    const list = [];
    if (startDate && endDate && awal !== 'Invalid date') {
      list.push({
        id: 'date',
        label: awal === akhir ? awal : `${awal} - ${akhir}`,
        icon: '📅',
        onClear: () => {
          setStartDate(null);
          setEndDate(null);
          setCurrentPage(1);
        },
      });
    }
    if (selectedKategori) {
      const namaKategori = (kategori || []).find((kt) => String(kt.id) === String(selectedKategori))?.nama_kategori || 'Kategori';
      list.push({
        id: 'kategori',
        label: namaKategori,
        icon: '🏷️',
        onClear: () => {
          setSelectedKategori('');
          setSelectJenisKategori('');
          setCurrentPage(1);
        },
      });
    }
    if (selectJenisKategori && selectedKategori) {
      const namaJenis = (kategori || [])
        .find((kt) => String(kt.id) === String(selectedKategori))
        ?.jenis_kategori?.find((jk) => String(jk.id) === String(selectJenisKategori))?.nama_jenis || 'Jenis';
      list.push({
        id: 'jenis',
        label: namaJenis,
        icon: '✨',
        onClear: () => {
          setSelectJenisKategori('');
          setCurrentPage(1);
        },
      });
    }
    if (selectedBaki && selectedBaki.length > 0) {
      list.push({
        id: 'baki',
        label: `Baki: ${selectedBaki.join(', ')}`,
        icon: '📥',
        onClear: () => {
          setSelectedBaki([]);
          setCurrentPage(1);
        },
      });
    }
    if (selectedKarat && selectedKarat.length > 0) {
      list.push({
        id: 'karat',
        label: `Karat: ${selectedKarat.map((k) => `${k}k`).join(', ')}`,
        icon: '💎',
        onClear: () => {
          setSelectedKarat([]);
          setCurrentPage(1);
        },
      });
    }
    if (berat || filterBerat) {
      list.push({
        id: 'berat',
        label: `Berat: ${berat || filterBerat} gr`,
        icon: '⚖️',
        onClear: () => {
          setFilterBerat('');
          setBerat('');
          setCurrentPage(1);
        },
      });
    }
    return list;
  }, [startDate, endDate, awal, akhir, selectedKategori, selectJenisKategori, kategori, selectedBaki, selectedKarat, berat, filterBerat]);

  const activeFilterCount = activeFilters.length;

  function refreshPage() {
    getItems();
  }

  // ═══ Auto-close Selection Preview ═══
  const previewRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (previewRef.current && !previewRef.current.contains(event.target)) {
        setShowSelectedPreview(false);
      }
    }
    if (showSelectedPreview) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSelectedPreview]);

  // ═══ Auto-close Karat Dropdown ═══
  const [isOpenKarat, setIsOpenKarat] = useState(false);
  const karatDropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutsideKarat(event) {
      if (karatDropdownRef.current && !karatDropdownRef.current.contains(event.target)) {
        setIsOpenKarat(false);
      }
    }
    if (isOpenKarat) {
      document.addEventListener('mousedown', handleClickOutsideKarat);
    } else {
      document.removeEventListener('mousedown', handleClickOutsideKarat);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideKarat);
    };
  }, [isOpenKarat]);

  // ═══ Auto-close Baki Dropdown ═══
  useEffect(() => {
    function handleClickOutsideBaki(event) {
      if (bakiDropdownRef.current && !bakiDropdownRef.current.contains(event.target)) {
        setIsOpenBaki(false);
      }
    }
    if (isOpenBaki) {
      document.addEventListener('mousedown', handleClickOutsideBaki);
    } else {
      document.removeEventListener('mousedown', handleClickOutsideBaki);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutsideBaki);
    };
  }, [isOpenBaki]);

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };
  function handleSelect(date) {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // useEffect(() => {
  //   async function getCabangSelect() {
  //     await http
  //       .get(`cabang`, {
  //         headers: { Authorization: getAuthorizationHeader() },
  //       })
  //       .then((res) => {
  //         setCabang(res.data.data);
  //       })
  //       .catch((err) => {
  //         if (err.response === 'undefined') {
  //           return null;
  //         } else if (err.response.status === 401) {
  //           navigate('/login');
  //         }
  //       });
  //   }
  //   getCabangSelect();
  // }, [navigate]);

  const handleKategoriChange = (event) => {
    setSelectedKategori(event.target.value);
    setSelectJenisKategori('');
  };

  const handleJenisKategoriChange = (event) => {
    setSelectJenisKategori(event.target.value);
  };

  const [search, setSearch] = useState('');
  const [scanInput, setScanInput] = useState('');
  const searchInputRef = useRef(null);
  const scanTimeoutRef = useRef(null);

  async function getItems() {
    const page = `?page=${currentPage}`;
    let queryBerat = '';
    if (berat) {
      queryBerat = `&berat=${encodeURIComponent(berat.trim())}`;
    }

    const perPageParam = `&per_page=${itemsPerPage || 10}`;
    setLoading(true);
    await http
      .get(
        `/item/brankas${search === '' ? page : `?kode=${search}`}${selectedKategori === '' ? `` : `&kategori=${selectedKategori}`}${selectJenisKategori === '' ? `` : `&jenis_kategori=${selectJenisKategori}`
        }${selectStatus === '' ? `` : `&status=${selectStatus}`}${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`
        }${selectedBaki.length === 0 ? '' : `&no_baki=${selectedBaki.join(',')}`}${selectedKarat.length === 0 ? '' : `&karat=${selectedKarat.join(',')}`}${queryBerat}&status_pengiriman=ready${perPageParam}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      )
      .then((res) => {
        setItems(res.data.data.data);
        setTotalModal(res.data.total_modal);
        setTotalModalFilter(res.data.total_modal_filter);
        setJmlBarang(res.data.data.total);
        setJmlBerat(res.data.total_berat_filter);
        setPage(res.data.data.last_page);
        // setPageFilterLoop(res.data.last_page);
        setItemsPerPage(res.data.data.per_page);
        setCurrentPage(res.data.data.current_page);
      })
      .catch((err) => {
        if (err.response === 'undefined') {
          return null;
        } else if (err.response?.status === 401) {
          navigate('/login');
        } else if (err.response?.status === 403) {
          toast.error('Akses ditolak: Anda tidak memiliki izin melihat data Brankas');
          navigate('/');
        }
      });
    setLoading(false);
  }

  const handleResetAndReload = async () => {
    setSelectedKategori('');
    setSelectJenisKategori('');
    setSelectedBaki([]);
    setSelectedKarat([]);
    setFilterBerat('');
    setBerat('');
    setSearch('');
    setScanInput('');
    setStartDate(null);
    setEndDate(null);
    setSelectedItems([]);
    setSelectPindahItems([]);
    setIsCheckedItems([]);
    setIsCheckedAll(false);
    setCurrentPage(1);
    setPageInput('1');

    setLoading(true);
    try {
      const res = await http.get(
        `/item/brankas?page=1&status_pengiriman=ready&per_page=${itemsPerPage || 10}`,
        { headers: { Authorization: getAuthorizationHeader() } }
      );
      if (res.data?.data) {
        setItems(res.data.data.data);
        setTotalModal(res.data.total_modal);
        setTotalModalFilter(res.data.total_modal_filter);
        setJmlBarang(res.data.data.total);
        setJmlBerat(res.data.total_berat_filter);
        setPage(res.data.data.last_page);
        setItemsPerPage(res.data.data.per_page);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPageInput(currentPage.toString());
  }, [currentPage]);

  const handlePageInputChange = (e) => {
    setPageInput(e.target.value);
  };

  const jumpToPage = () => {
    const pageNumber = parseInt(pageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= page) {
      setCurrentPage(pageNumber);
    } else {
      setPageInput(currentPage.toString());
    }
  };

  const handlePageInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      jumpToPage();
      e.target.blur();
    }
  };

  useEffect(() => {
    const roleCheck = localStorage.getItem('role');
    if (roleCheck === 'operator' || roleCheck === 'kasir') {
      toast.error('Akses ditolak: Role kasir/operator tidak memiliki izin untuk melihat data Brankas.');
      navigate('/');
      return;
    }
    if (!isPinVerified) return;
    getItems();
  }, [
    selectedKategori,
    selectedBaki,
    isDelete,
    search.length >= 10 ? search : '',
    selectJenisKategori,
    isEdit,
    currentPage,
    selectStatus,
    awal,
    akhir,
    isSubmitItem,
    selectedKarat,
    berat,
    isPinVerified,
    itemsPerPage
  ]);
  function closeModal() {
    setIsOpen(false);
  }
  function closeModalDetail() {
    setOpenDetail(false);
  }

  function openModal() {
    setIsOpen(true);
    // console.log('hallo');
  }
  function checkBerat(number) {
    const beratConfirm = parseFloat(number);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
        .toFixed(2)
        .replace(/\.?0+$/, '')
        .replace('.', ',');
  }

  const { pageOption, pageOptionId, setPageOptionId } = usePage();

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectPindahItems, setSelectPindahItems] = useState([]);
  const [isCheckedItems, setIsCheckedItems] = useState([]);

  // Calculate if all items on current page are selected
  const isCheckedAll = items.length > 0 && items.every((item) => selectedItems.some((si) => si.id === item.id));
  const setIsCheckedAll = () => {};

  const resetSelectPindahItems = () => {
    setSelectedItems([]);
    setSelectPindahItems([]);
    setIsCheckedItems(items.map(() => false));
  };

  // console.log(selectPindahItems);
  // SELECT CHECKBOX
  function handleCheckboxChange(event, item) {
    if (event.target.checked) {
      // Cek apakah item sudah ada di selectedItems (berdasarkan id)
      const alreadySelected = selectedItems.some((si) => si.id === item.id);
      if (alreadySelected) {
        toast.info('Data ini sudah dipilih sebelumnya.', { autoClose: 2000 });
        event.target.checked = false;
        return;
      }
      setSelectedItems([...selectedItems, item]);
      setSelectPindahItems([...selectPindahItems, item]);
    } else {
      setSelectedItems(selectedItems.filter((si) => si.id !== item.id));
      setSelectPindahItems(selectPindahItems.filter((si) => si.id !== item.id));
    }
  }

  function handleCheckAll(event) {
    if (event.target.checked) {
      // Tambahkan item dari halaman saat ini yang belum ada di selectedItems
      const newItemsToAdd = items.filter((item) => !selectedItems.some((si) => si.id === item.id));
      const newSelected = [...selectedItems, ...newItemsToAdd];
      setSelectedItems(newSelected);
      setSelectPindahItems(newSelected);
      setIsCheckedItems(items.map(() => true));
    } else {
      // Hapus hanya item dari halaman saat ini, pertahankan pilihan dari halaman lain
      const currentPageIds = new Set(items.map((it) => it.id));
      const remainingSelected = selectedItems.filter((si) => !currentPageIds.has(si.id));
      setSelectedItems(remainingSelected);
      setSelectPindahItems(remainingSelected);
      setIsCheckedItems(items.map(() => false));
    }
  }
  // END SELECT CHECKBOX


  // ═══ Barcode Scan Auto-Select ═══
  const handleScanSearch = useCallback(async (kode) => {
    try {
      const res = await http.get(`/item/brankas?kode=${kode}&status_pengiriman=ready`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      const foundItems = res.data.data.data;
      if (foundItems && foundItems.length > 0) {
        const item = foundItems[0];
        const alreadySelected = selectedItems.some((si) => si.id === item.id);
        if (alreadySelected) {
          toast.info(`${item.kode_item} sudah dipilih sebelumnya`, { autoClose: 1500 });
        } else {
          setSelectedItems((prev) => [...prev, item]);
          setSelectPindahItems((prev) => [...prev, item]);
          toast.success(`${item.kode_item} berhasil dipilih ✓`, { autoClose: 1500 });
        }
      } else {
        toast.error(`Item dengan kode "${kode}" tidak ditemukan`, { autoClose: 2000 });
      }
    } catch (err) {
      if (err.response?.status === 401) {
        navigate('/login');
      } else {
        toast.error('Gagal mencari item', { autoClose: 2000 });
      }
    } finally {
      // Clear input and refocus for next scan
      setScanInput('');
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }
  }, [selectedItems, navigate]);

  // Trigger scan search when input reaches barcode length
  useEffect(() => {
    if (scanInput.length >= 10) {
      // Small debounce to allow barcode scanner to finish
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
      scanTimeoutRef.current = setTimeout(() => {
        setSearch(scanInput); // Also update search for getItems
        handleScanSearch(scanInput);
      }, 300);
    }
    return () => {
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
    };
  }, [scanInput]);
  function closeModalPrintBandrol() {
    setOpenPrintBandrol(false);
  }
  function closeModalPindahBarangBanyak() {
    setOpenPindahBanyakBarang(false);
  }
  function openModalPindahBarangBanyak() {
    setOpenPindahBanyakBarang(true);
  }
  function openModalPrintBandrol() {
    if (selectedItems.length > 10) {
      toast.error('Maksimal 10 item untuk cetak bandrol');
      return;
    }
    setOpenPrintBandrol(true);
  }


  //ini untuk hapus banyak barang
  //start
  function closeModalHapusBarangBanyak() {
    setOpenHapusBanyakBarang(false);
  }
  function openModalHapusBarangBanyak() {
    setOpenHapusBanyakBarang(true);
  }
  //end


  //ini untuk pindah banyak baki
  //start
  function closeModalPindahBarangBaki() {
    setOpenPindahBanyakBaki(false);
  }
  function openModalPindahBarangBaki() {
    setOpenPindahBanyakBaki(true);
  }
  //end


  function setPageFilterCurrent(val) {
    setCurrentPage(val);
    setPageFilter(val)
  }

  function nextPage() {
    setCurrentPage(currentPage + 1);
  }

  function prevPage() {
    setCurrentPage(currentPage - 1);
  }
  DinamicTitle('List Brankas || Komaladewi');

  let [isOpenEditItem, setIsOpenEditItem] = useState(false);

  function closeModalEditItem() {
    setIsOpenEditItem(false);
  }

  function openModalEditItem() {
    setIsOpenEditItem(true);
  }

  async function getItemEdit(id) {
    setOpenLoading(true);
    await http
      .get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDetailItem(res.data.data);
        openModalEditItem();
      });
    setOpenLoading(false);
  }

  const startIndex = (currentPage - 1) * itemsPerPage;

  function showDetailItem(id) {
    // Cari data item dari state items yang sudah di-load di halaman ini
    const selectedItem = items.find(item => item.id === id);
    if (selectedItem) {
      setDetailItem(selectedItem);
      setOpenDetail(true);
    } else {
      toast.error('Data item tidak ditemukan di halaman ini', { autoClose: 2000 });
    }
  }

  let [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  let [isOpenModalPindah, setIsOpenModalPindah] = useState(false);
  const [loadingPin, setLoadingPin] = useState(false);


  function closeModaDelete() {
    setIsOpenModalDelete(false);
  }

  function openModalDelete() {
    setIsOpenModalDelete(true);
  }

  function closeModaPindah() {
    setIsOpenModalPindah(false);
  }

  function openModalPindah() {
    setIsOpenModalPindah(true);
  }

  async function getIdPindahItem(id) {
    setLoadingPin(true);
    await http
      .get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDetailItem(res.data.data);
        openModalPindah();
        setLoadingPin(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getIdDelete(id) {

    setLoadingDel(true);
    await http
      .get(`item/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        openModalDelete();
        setDeleteId(res.data.data.id);
        setBarangDelete(res.data.data);
        setLoadingDel(false);
      })
      .catch((err) => {
        console.log(err);
      });
    setLoadingDel(false);
  }
  const [keterangan, setKeterangan] = useState('')
  async function deleteBarang(e) {
    if (e) e.preventDefault();
    if (!keterangan.trim()) {
      toast.error('Alasan penghapusan harus diisi', { autoClose: 1500 });
      return;
    }
    setIsDelete(true);

    const userRole = localStorage.getItem('role');
    const roleIsAdminOrOwner = userRole === 'admin' || userRole === 'owner';
    let url = '/item-deletions/brankas-toko/salah-input';
    
    let formData = {
      items: [deleteId],
      alasan: keterangan,
      tipe_penghapusan: 'brankas_pusat'
    };

    await http
      .post(url, formData, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        closeModaDelete();
        toast.success('Data berhasil dihapus', { autoClose: 600, });
        getItems();
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response?.data?.message || 'Gagal menghapus data', { autoClose: 1500 });
      });
    setIsDelete(false);
  }

  const user = localStorage.getItem('role');
  const [openModalTransferToToko, setOpenModalTransferToToko] = useState(false);
  const [isOpenModalPengiriman, setIsOpenModalPengiriman] = useState(false);
  const [openTransferAntarToko, setOpenTransferAntarToko] = useState(false);
  function closeOpenModalTransferToToko() {
    setOpenModalTransferToToko(false);
  }
  function reloadDate() {
    getItems();
  }

  return (
    <>
      {!isPinVerified && (
        <PinBrankas onSuccess={() => {
          sessionStorage.setItem('brankasPinVerified', 'true');
          setIsPinVerified(true);
        }} />
      )}
      <Layouts
        title={'List Barang (Brankas)'}
        dateFilter={`${awal === 'Invalid date' ? '' : ` ${awal}`} ${awal === akhir ? `` : `${akhir === 'Invalid date' ? '' : ` s/d ${akhir}`}`}`}
        openModal={openModal}
      >
      <ConfirmationDeleteItem
        reloadDate={reloadDate}
        isDelete={isDelete}
        deleteBarang={deleteBarang}
        setKeterangan={setKeterangan}
        barangDelete={barangDelete}
        isOpenModalDelete={isOpenModalDelete}
        closeModaDelete={closeModaDelete}
        customTitle="Hapus Barang (Salah Input)"
      />
      <InputBarang
        setIsSubmitItem={() => setIsSubmitItem(true)}
        closeModal={closeModal}
        isOpen={isOpen}
        kategori={kategori}
      />
      <EditItem
        setIsEdit={setIsEdit}
        kategori={kategori}
        cabang={cabang}
        detailItem={detailItem}
        isOpenEditItem={isOpenEditItem}
        closeModalEditItem={closeModalEditItem}
      />
      <DetailItem
        checkBerat={checkBerat}
        detailItem={detailItem}
        closeModalDetail={closeModalDetail}
        openDetail={openDetail}
      />
      {openLoading || loadingDel || loadingPin ? (
        <LoadingIndicator />
      ) : (
        ''
      )}

      {/* ═══ Filter & Action Toolbar ═══ */}
      <div className="relative z-30 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border-b border-amber-100/80 dark:border-slate-700/80 px-3 sm:px-4 py-2 sm:py-2.5 transition-colors shadow-xs">
        <div className="flex flex-col gap-2 w-full max-w-full">
          {/* Baris 1: Pencarian & Tombol Kontrol Utama */}
          <div className="flex items-center gap-1.5 sm:gap-2 w-full">
            {/* Search Input (Dominant width) */}
            <div className="relative flex-1 min-w-0">
              <IconSearch size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 pointer-events-none" />
              <Input
                ref={searchInputRef}
                value={scanInput}
                onChange={(e) => {
                  setScanInput(e.target.value);
                  if (e.target.value.length < 10) {
                    setSearch(e.target.value);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    setSearch(scanInput);
                    setCurrentPage(1);
                  }
                }}
                className="w-full pl-9 pr-8 py-1.5 sm:py-2 text-xs sm:text-sm rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 text-left outline-none transition-all shadow-xs"
                autoComplete="off"
                type="search"
                name="search"
                placeholder="Scan barcode / cari kode barang..."
              />
              {scanInput && (
                <button
                  type="button"
                  onClick={() => {
                    setScanInput('');
                    setSearch('');
                    setCurrentPage(1);
                  }}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 p-0.5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 rounded-full cursor-pointer"
                  title="Hapus pencarian"
                >
                  <IconX size={14} />
                </button>
              )}
            </div>

            {/* Filter Toggle Button */}
            <button
              type="button"
              onClick={() => setIsFilterOpen(true)}
              className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-lg text-xs sm:text-sm font-semibold border transition-all shrink-0 cursor-pointer shadow-xs ${
                isFilterOpen || activeFilterCount > 0
                  ? 'bg-amber-500 border-amber-600 text-white shadow-amber-500/20'
                  : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-600 text-slate-700 dark:text-slate-200 hover:border-amber-300 dark:hover:border-amber-500'
              }`}
              title="Buka Filter Barang"
            >
              <IconAdjustmentsHorizontal size={16} />
              <span className="hidden sm:inline">Filter</span>
              {activeFilterCount > 0 && (
                <span className={`px-1.5 py-0.2 text-[10px] font-bold rounded-full leading-tight ${
                  isFilterOpen || activeFilterCount > 0
                    ? 'bg-white text-amber-700'
                    : 'bg-amber-500 text-white'
                }`}>
                  {activeFilterCount}
                </span>
              )}
            </button>

            {/* Reload / Refresh Button */}
            <button
              type="button"
              onClick={handleResetAndReload}
              className="bg-slate-700 hover:bg-slate-800 text-white p-1.5 sm:p-2 cursor-pointer rounded-lg shadow-xs hover:shadow transition-all duration-200 shrink-0"
              title="Reset & Reload Data"
            >
              <IconReload size={18} />
            </button>

            {/* Quick Button: Buat Pengiriman ke Toko (Khusus Supervisor) */}
            {user === 'supervisor' && (
              <button
                type="button"
                onClick={() => setIsOpenModalPengiriman(true)}
                className="flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white rounded-lg text-xs sm:text-sm font-bold shadow-xs hover:shadow transition-all shrink-0 cursor-pointer"
                title="Buat Pengiriman Barang dari Brankas ke Etalase Toko"
              >
                <IconTruckDelivery size={16} />
                <span className="hidden sm:inline">Buat Pengiriman</span>
              </button>
            )}

            {/* Quick Bulk Action Buttons (Only visible when items are selected) */}
            {selectedItems.length > 0 && (
              <div className="flex items-center gap-1 sm:gap-1.5 shrink-0 pl-1 border-l border-slate-200 dark:border-slate-700 animate-[fadeIn_0.2s_ease-out]">
                {user !== 'owner' && user !== 'admin' && (
                  <span className="hidden md:inline-block text-[11px] font-bold text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/50 px-2 py-1 rounded-md shrink-0">
                    {selectedItems.length} Dipilih
                  </span>
                )}

                {/* Kirim / Pindah ke Etalase Toko (Owner / Admin / Supervisor) */}
                {(user === 'owner' || user === 'admin' || user === 'supervisor') && (
                  <button
                    type="button"
                    onClick={() => setOpenTransferAntarToko(true)}
                    className="p-1.5 sm:p-2 cursor-pointer rounded-lg shadow-xs hover:shadow transition-all duration-200 bg-amber-500 hover:bg-amber-600 text-white"
                    title={`Kirim / Pindah ke Etalase Toko (${selectedItems.length} Barang)`}
                  >
                    <IconBuildingStore size={18} />
                  </button>
                )}

                {user === 'operator_rumah' && (
                  <button
                    type="button"
                    onClick={openModalPindahBarangBanyak}
                    className="p-1.5 sm:p-2 cursor-pointer rounded-lg shadow-xs hover:shadow transition-all duration-200 bg-blue-500 hover:bg-blue-600 text-white"
                    title={`Request Pemindahan ${selectedItems.length} Barang ke Brankas Pusat`}
                  >
                    <IconTransferOut size={18} />
                  </button>
                )}

                {(user === 'admin' || user === 'owner' || user === 'operator_rumah') && (
                  <button
                    type="button"
                    onClick={openModalHapusBarangBanyak}
                    className="p-1.5 sm:p-2 cursor-pointer rounded-lg shadow-xs hover:shadow transition-all duration-200 bg-red-500 hover:bg-red-600 text-white"
                    title={`Hapus ${selectedItems.length} Barang`}
                  >
                    <IconTrash size={18} />
                  </button>
                )}

                {user !== 'admin' && user !== 'supervisor' && (
                  <button
                    type="button"
                    onClick={openModalPindahBarangBaki}
                    className="p-1.5 sm:p-2 cursor-pointer rounded-lg shadow-xs hover:shadow transition-all duration-200 bg-emerald-500 hover:bg-emerald-600 text-white"
                    title={`Pindah Baki ${selectedItems.length} Barang`}
                  >
                    <IconRefresh size={18} />
                  </button>
                )}

                <button
                  type="button"
                  onClick={openModalPrintBandrol}
                  className="p-1.5 sm:p-2 cursor-pointer rounded-lg shadow-xs hover:shadow transition-all duration-200 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white"
                  title={selectedItems.length > 10 ? 'Maksimal 10 item untuk print' : `Print ${selectedItems.length} Bandrol`}
                >
                  <IconPrinter size={18} />
                </button>
              </div>
            )}
          </div>

          {/* Baris 2: Active Filter Chips (Pills horizontal scroll) */}
          {activeFilterCount > 0 && (
            <div className="flex items-center gap-1.5 overflow-x-auto py-1 w-full max-w-full no-scrollbar text-xs">
              <span className="text-[11px] font-semibold text-slate-400 dark:text-slate-500 shrink-0 uppercase tracking-wider">
                Filter:
              </span>
              {activeFilters.map((flt) => (
                <div
                  key={flt.id}
                  className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-amber-800 dark:text-amber-300 font-medium whitespace-nowrap shadow-2xs shrink-0"
                >
                  <span className="text-xs">{flt.icon}</span>
                  <span className="max-w-[150px] sm:max-w-[200px] truncate">{flt.label}</span>
                  <button
                    type="button"
                    onClick={flt.onClear}
                    className="p-0.5 hover:bg-amber-200/60 dark:hover:bg-amber-800/60 rounded-full transition-colors ml-0.5 cursor-pointer text-amber-600 dark:text-amber-400"
                    title={`Hapus filter ${flt.label}`}
                  >
                    <IconX size={12} />
                  </button>
                </div>
              ))}

              <button
                type="button"
                onClick={handleResetAndReload}
                className="text-[11px] font-bold text-rose-600 dark:text-rose-400 hover:underline px-2 py-0.5 rounded shrink-0 cursor-pointer whitespace-nowrap"
              >
                Reset Semua
              </button>
            </div>
          )}

          {/* ═══ Filter Slide-over Drawer (Muncul dari Kanan Layar & Kiri Transparan) ═══ */}
          <Transition appear show={isFilterOpen} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-[99999]"
              onClose={() => setIsFilterOpen(false)}
            >
              {/* Backdrop Overlay Tipis & Tanpa Blur (Layar kiri transparan, data tabel brankas tetap terbaca jelas) */}
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-slate-900/15 dark:bg-black/30 pointer-events-auto" />
              </Transition.Child>

              {/* Drawer Container */}
              <div className="fixed inset-0 overflow-hidden pointer-events-none">
                <div className="fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-10">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-300 sm:duration-400"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-300 sm:duration-400"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <Dialog.Panel className="pointer-events-auto w-screen max-w-[340px] sm:max-w-[420px] transform bg-white dark:bg-slate-900 shadow-2xl border-l border-slate-200 dark:border-slate-800 text-left align-middle transition-all flex flex-col h-screen max-h-screen">
                      {/* Drawer Header */}
                      <div className="px-4 py-3.5 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex items-center justify-between shrink-0 sticky top-0 z-20">
                        <div className="flex items-center gap-2">
                          <div className="p-1.5 rounded-xl bg-amber-500/10 text-amber-600 dark:text-amber-400">
                            <IconAdjustmentsHorizontal size={18} />
                          </div>
                          <div>
                            <Dialog.Title as="h2" className="text-sm font-bold text-slate-800 dark:text-slate-100">
                              Filter Barang (Brankas)
                            </Dialog.Title>
                            <p className="text-[11px] text-slate-500 dark:text-slate-400">
                              {activeFilterCount > 0
                                ? `${activeFilterCount} kriteria aktif`
                                : 'Filter pencarian brankas'}
                            </p>
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => setIsFilterOpen(false)}
                          className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 transition cursor-pointer"
                          title="Tutup Filter"
                        >
                          <IconX size={16} />
                        </button>
                      </div>

                      {/* Drawer Body (Scrollable) */}
                      <div className="p-4 flex-1 bg-slate-50/50 dark:bg-slate-900/50 overflow-y-auto space-y-3.5">
                        {/* 1. Filter Tanggal */}
                        <div className="space-y-1.5">
                          <div className="dropdown dropdown-bottom w-full">
                            <div
                              tabIndex={0}
                              className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 flex items-center justify-between gap-1.5 shadow-xs"
                              title="Filter Tanggal"
                            >
                              <div className="flex items-center gap-2 truncate">
                                <IconCalendarTime size={16} className="text-amber-500 shrink-0" />
                                <span className="truncate">
                                  {startDate && endDate && awal !== 'Invalid date'
                                    ? awal === akhir
                                      ? awal
                                      : `${awal} - ${akhir}`
                                    : 'Pilih Rentang Tanggal'}
                                </span>
                              </div>
                              <IconChevronDown size={14} className="text-slate-400 shrink-0" />
                            </div>
                            <div
                              tabIndex={0}
                              className="dropdown-content menu p-2 shadow-2xl bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 z-[9999] mt-1 left-0 max-w-[92vw] overflow-x-auto"
                            >
                              <DateRange ranges={[selectionRange]} onChange={handleSelect} />
                              {startDate && (
                                <div className="p-2 border-t border-slate-200 dark:border-slate-700 flex justify-end">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setStartDate(null);
                                      setEndDate(null);
                                      setCurrentPage(1);
                                    }}
                                    className="text-xs text-rose-500 hover:underline font-bold cursor-pointer"
                                  >
                                    Reset Tanggal
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* 2. Kategori */}
                        <div className="space-y-1.5">
                          <select
                            value={selectedKategori}
                            onChange={handleKategoriChange}
                            className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none shadow-xs"
                          >
                            <option value="">Semua Kategori</option>
                            {kategori.map((kt) => (
                              <option key={kt.id} value={kt.id}>
                                {kt.nama_kategori}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* 3. Jenis Kategori */}
                        <div className="space-y-1.5">
                          <select
                            onChange={handleJenisKategoriChange}
                            value={selectJenisKategori}
                            disabled={!selectedKategori}
                            className={`w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl px-3 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 outline-none shadow-xs ${
                              !selectedKategori
                                ? 'opacity-50 cursor-not-allowed'
                                : 'cursor-pointer hover:border-amber-300 dark:hover:border-amber-500'
                            }`}
                          >
                            <option value="">Semua Jenis</option>
                            {selectedKategori &&
                              kategori
                                .find((kt) => kt.id === parseInt(selectedKategori, 10))
                                ?.jenis_kategori?.map((jk) => (
                                  <option key={jk.id} value={jk.id}>
                                    {jk.nama_jenis}
                                  </option>
                                ))}
                          </select>
                        </div>

                        {/* 4. Pilihan Baki Grid */}
                        <div className="space-y-1.5">
                          {selectedBaki.length > 0 && (
                            <div className="flex items-center justify-end">
                              <button
                                type="button"
                                onClick={() => {
                                  setSelectedBaki([]);
                                  setCurrentPage(1);
                                }}
                                className="text-xs text-rose-500 hover:text-rose-600 font-bold hover:underline cursor-pointer"
                              >
                                Reset Baki ({selectedBaki.length} dipilih)
                              </button>
                            </div>
                          )}
                          <div className="p-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl max-h-44 overflow-y-auto">
                            <div className="grid grid-cols-3 gap-1.5">
                              {bakiOption.map((ftb) => {
                                const ftbStr = String(ftb);
                                const isChecked = selectedBaki.includes(ftbStr) || selectedBaki.includes(ftb);
                                return (
                                  <label
                                    key={ftb}
                                    className={`flex items-center gap-1.5 p-1.5 rounded-lg border text-xs cursor-pointer transition-all ${
                                      isChecked
                                        ? 'bg-amber-50 dark:bg-amber-950/40 border-amber-400 text-amber-800 dark:text-amber-300 font-bold shadow-2xs'
                                        : 'border-slate-100 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700/50 text-slate-700 dark:text-slate-300'
                                    }`}
                                  >
                                    <input
                                      type="checkbox"
                                      className="checkbox checkbox-xs checkbox-warning rounded"
                                      checked={isChecked}
                                      onChange={() => handleSelectBaki(ftb)}
                                    />
                                    <span className="truncate">{ftb}</span>
                                  </label>
                                );
                              })}
                            </div>
                          </div>
                        </div>

                        {/* 5. Pilihan Karat Grid */}
                        <div className="space-y-1.5">
                          {selectedKarat.length > 0 && (
                            <div className="flex items-center justify-end">
                              <button
                                type="button"
                                onClick={() => {
                                  setSelectedKarat([]);
                                  setCurrentPage(1);
                                }}
                                className="text-xs text-rose-500 hover:text-rose-600 font-bold hover:underline cursor-pointer"
                              >
                                Reset Karat ({selectedKarat.length} dipilih)
                              </button>
                            </div>
                          )}
                          <div className="p-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl">
                            <div className="grid grid-cols-3 gap-1.5 max-h-36 overflow-y-auto">
                              {karatOption.map((kto) => {
                                const ktoStr = String(kto);
                                const isChecked = selectedKarat.includes(ktoStr) || selectedKarat.includes(kto);
                                return (
                                  <label
                                    key={kto}
                                    className={`flex items-center gap-1.5 p-1.5 rounded-lg border text-xs cursor-pointer transition-all ${
                                      isChecked
                                        ? 'bg-amber-50 dark:bg-amber-950/40 border-amber-400 text-amber-800 dark:text-amber-300 font-bold shadow-2xs'
                                        : 'border-slate-100 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700/50 text-slate-700 dark:text-slate-300'
                                    }`}
                                  >
                                    <input
                                      type="checkbox"
                                      className="checkbox checkbox-xs checkbox-warning rounded"
                                      checked={isChecked}
                                      onChange={() => handleSelectKarat(kto)}
                                    />
                                    <span>{kto}k</span>
                                  </label>
                                );
                              })}
                            </div>
                          </div>
                        </div>

                        {/* 6. Filter Berat */}
                        <div className="space-y-1.5">
                          <div className="relative">
                            <input
                              value={filterBerat}
                              onChange={(e) => setFilterBerat(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  filterBeratBarang();
                                }
                              }}
                              placeholder="Berat barang (contoh: 10, ~10)"
                              className="w-full h-10 border border-slate-200 dark:border-slate-600 rounded-xl pl-3 pr-10 text-xs sm:text-sm bg-white dark:bg-slate-800 dark:text-slate-200 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none shadow-xs"
                            />
                            <button
                              type="button"
                              onClick={filterBeratBarang}
                              className="absolute right-1 top-1/2 -translate-y-1/2 p-2 text-amber-600 hover:text-amber-700 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-slate-700 rounded-lg transition-colors cursor-pointer"
                              title="Terapkan Berat"
                            >
                              <IconSearch size={16} />
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Drawer Footer (Sticky) */}
                      <div className="px-4 py-3 border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex items-center justify-between gap-2 shrink-0">
                        {activeFilterCount > 0 ? (
                          <button
                            type="button"
                            onClick={handleResetAndReload}
                            className="px-2.5 py-1.5 text-xs font-semibold text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-950/40 rounded-xl transition cursor-pointer"
                          >
                            Reset ({activeFilterCount})
                          </button>
                        ) : (
                          <div />
                        )}
                        <button
                          type="button"
                          onClick={() => setIsFilterOpen(false)}
                          className="px-3.5 py-1.5 text-xs font-bold bg-amber-500 hover:bg-amber-600 active:scale-95 text-white rounded-xl shadow-xs transition cursor-pointer"
                        >
                          Tutup
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>
        </div>
      </div>

      {/* ═══ Modals for bulk actions ═══ */}
      <div className="flex-1 flex flex-col">
        <PrintBandrol
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          openPrintBandrol={openPrintBandrol}
          closeModalPrintBandrol={closeModalPrintBandrol}
        />
        <ModalTransferAntarToko
          isOpen={openTransferAntarToko}
          onClose={() => setOpenTransferAntarToko(false)}
          selectedItems={selectedItems}
          setSelectedItems={(updated) => {
            const nextItems = typeof updated === 'function' ? updated(selectedItems) : updated;
            setSelectedItems(nextItems);
            setSelectPindahItems(nextItems);
          }}
          onSuccess={() => {
            getItems();
            resetSelectPindahItems();
          }}
          title="Kirim ke Etalase Toko"
        />
        <ModalBuatPengirimanCepat
          isOpen={isOpenModalPengiriman}
          onClose={() => setIsOpenModalPengiriman(false)}
          selectedItems={selectedItems}
          setSelectedItems={(updated) => {
            setSelectedItems(updated);
            setSelectPindahItems(updated);
          }}
          onSuccess={() => {
            getItems();
            resetSelectPindahItems();
          }}
        />
        <TransferBarangToCabang
          openPindahBarangBanyak={openModalTransferToToko}
          setOpenPindahBanyakBarang={setOpenModalTransferToToko}
          reloadDate={reloadDate}
          closeModalBanyakBarang={closeOpenModalTransferToToko}
          selectedItems={selectPindahItems}
          refreshPage={refreshPage}
          setSelectedItems={setSelectPindahItems}
          resetSelectPindahItems={resetSelectPindahItems}
        />
        <TransferBanyakBarang
          cabang={cabang}
          reloadDate={reloadDate}
          selectedItems={selectPindahItems}
          setSelectedItems={setSelectPindahItems}
          openPindahBarangBanyak={openPindahBanyakBarang}
          setOpenPindahBanyakBarang={setOpenPindahBanyakBarang}
          closeModalBanyakBarang={closeModalPindahBarangBanyak}
          refreshPage={refreshPage}
          resetSelectPindahItems={resetSelectPindahItems}
        />

        <HapusBanyakBarang
          cabang={cabang}
          reloadDate={reloadDate}
          selectedItems={selectPindahItems}
          setSelectedItems={setSelectPindahItems}
          openHapusBarangBanyak={openHapusBanyakBarang}
          setOpenHapusBanyakBarang={setOpenHapusBanyakBarang}
          closeModalBanyakBarang={closeModalHapusBarangBanyak}
          refreshPage={refreshPage}
          resetSelectPindahItems={resetSelectPindahItems}
        />

        <PindahBakiBanyak
          reloadDate={reloadDate}
          selectedItems={selectPindahItems}
          setSelectedItems={setSelectPindahItems}
          openPindahBanyakBaki={openPindahBanyakBaki}
          setOpenPindahBanyakBaki={setOpenPindahBanyakBaki}
          closeModalBanyakBarang={closeModalPindahBarangBaki}
          refreshPage={refreshPage}
          resetSelectPindahItems={resetSelectPindahItems}
        />

        {/* ═══ Loading State ═══ */}
        {loading ? (
          <div className="flex items-center justify-center py-16">
            <div className="flex flex-col items-center gap-3">
              <div className="w-10 h-10 border-3 border-amber-200 dark:border-amber-800 border-t-amber-500 dark:border-t-amber-400 rounded-full animate-spin"></div>
              <span className="text-sm font-medium text-slate-500 dark:text-slate-400">Memuat data...</span>
            </div>
          </div>
        ) : (
          /* ═══ Data Table ═══ */
          <div className="relative overflow-x-auto mx-3 mt-3 mb-4 rounded-md border border-slate-200/60 dark:border-slate-700/60 shadow-sm bg-white dark:bg-slate-900 min-h-[380px]">
            <table className="w-full text-xs sm:text-sm text-left dark:text-slate-300">
              <thead>
                <tr className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/30 dark:via-amber-800/20 dark:to-amber-900/30">
                  <th scope="col" className="px-3 py-2.5 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    No
                  </th>
                  <th scope="col" className="px-3.5 py-2.5 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Kode Barang
                  </th>
                  <th scope="col" className="px-3.5 py-2.5 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Nama Barang
                  </th>
                  <th scope="col" className="px-3.5 py-2.5 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Baki
                  </th>
                  <th scope="col" className="px-3.5 py-2.5 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Berat | Karat
                  </th>
                  <th scope="col" className="px-3.5 py-2.5 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Ukuran
                  </th>
                  <th scope="col" className="px-3.5 py-2.5 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Lokasi
                  </th>
                  <th scope="col" className="px-3.5 py-2.5 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">
                    Tanggal
                  </th>
                  <th scope="col" className="px-3 py-2.5 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-center">
                    Aksi
                  </th>
                  <th scope="col" className="px-3.5 py-2.5 text-center">
                    <input
                      type="checkbox"
                      checked={isCheckedAll}
                      onChange={handleCheckAll}
                      className="cursor-pointer checkbox checkbox-warning w-[18px] h-[18px] border-amber-400 dark:border-slate-500 rounded transition-all"
                      title="Pilih Semua"
                    />
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-700 bg-white dark:bg-slate-900">
                <DefaultItem
                  cabang={cabang}
                  currentPage={currentPage}
                  setSelectedItems={setSelectedItems}
                  startIndex={startIndex}
                  getIdDelete={getIdDelete}
                  getIdPindahItem={getIdPindahItem}
                  page={page}
                  handleCheckboxChange={handleCheckboxChange}
                  selectedItems={selectedItems}
                  checkBerat={checkBerat}
                  showDetailItem={showDetailItem}
                  openModalEditItem={openModalEditItem}
                  getItemEdit={getItemEdit}
                  items={items}
                  search={search}
                  isCheckedItems={isCheckedItems}
                  hideDetail={true}
                  hideEdit={true}
                  showUkuran={true}
                  tdPadding="px-3.5 py-2.5"
                />
              </tbody>
              {items?.length > 0 && (
                <tfoot className="bg-amber-50/50 dark:bg-slate-800/80 border-t border-amber-200/60 dark:border-slate-700/60 font-semibold text-amber-900 dark:text-amber-100">
                  <tr>
                    <td colSpan="4" className="px-3.5 py-2.5 text-right">Total Berat Halaman Ini:</td>
                    <td className="px-3.5 py-2.5 whitespace-nowrap">{parseFloat(items.reduce((acc, curr) => acc + Number(curr.berat), 0).toFixed(3))} gr</td>
                    <td colSpan="4" className="px-3.5 py-2.5"></td>
                    <td className="px-3.5 py-2.5 text-center">
                      <input
                        type="checkbox"
                        checked={isCheckedAll}
                        onChange={handleCheckAll}
                        className="cursor-pointer checkbox checkbox-warning w-[18px] h-[18px] border-amber-400 dark:border-slate-500 rounded transition-all"
                        title="Pilih Semua"
                      />
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>

            {/* Trigger Checkbox All di bawah tfooter */}
            {/* {items?.length > 0 && (
              <div className="flex items-center justify-between px-4 py-2.5 bg-amber-50/40 dark:bg-slate-800/80 border-t border-amber-200/60 dark:border-slate-700/60 text-xs text-slate-700 dark:text-slate-300">
                <div className="flex items-center gap-2">
                  <input
                    id="checkbox-all-bottom"
                    type="checkbox"
                    checked={isCheckedAll}
                    onChange={handleCheckAll}
                    className="cursor-pointer checkbox checkbox-warning w-5 h-5 rounded-md border-amber-400 dark:border-slate-500"
                  />
                  <label htmlFor="checkbox-all-bottom" className="cursor-pointer select-none font-semibold text-slate-700 dark:text-slate-200">
                    Pilih Semua ({items.length} item di halaman ini)
                  </label>
                </div>
                {selectedItems.length > 0 && (
                  <span className="font-semibold text-amber-600 dark:text-amber-400">
                    {selectedItems.length} item terpilih
                  </span>
                )}
              </div>
            )} */}
          </div>
        )}
        {/* ═══ Floating Quick Action Bar ═══ */}
        {selectedItems.length > 0 && !openPrintBandrol && !openPindahBanyakBarang && !openHapusBanyakBarang && !openPindahBanyakBaki && !openModalTransferToToko && !openTransferAntarToko && !isOpenModalPengiriman && !openDetail && (
          <div ref={previewRef} className="fixed bottom-16 sm:bottom-20 left-1/2 -translate-x-1/2 z-40 w-[95%] sm:w-auto max-w-[600px] animate-[slideUp_0.3s_ease-out]">
            {/* Selected Items Preview Panel */}
            {showSelectedPreview && (
              <div className="mb-2 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md rounded-2xl shadow-2xl border border-amber-200/60 dark:border-slate-600/60 w-full sm:w-[420px] max-h-[280px] overflow-hidden flex flex-col mx-auto">
                <div className="flex items-center justify-between px-3 sm:px-4 py-2 sm:py-2.5 border-b border-slate-100 dark:border-slate-700">
                  <span className="text-xs font-bold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Item Dipilih ({selectedItems.length})</span>
                  <button
                    onClick={() => setShowSelectedPreview(false)}
                    className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors p-1"
                  >
                    <IconX size={16} />
                  </button>
                </div>
                <div className="overflow-y-auto flex-1 divide-y divide-slate-100 dark:divide-slate-700/50">
                  {selectedItems.map((item, idx) => (
                    <div key={item.id} className="flex items-center justify-between px-3 sm:px-4 py-2 hover:bg-amber-50/50 dark:hover:bg-slate-700/30 transition-colors">
                      <div className="flex items-center gap-2 sm:gap-2.5 min-w-0">
                        <span className="text-[10px] font-bold text-slate-400 dark:text-slate-500 w-4 sm:w-5 text-center flex-shrink-0">{idx + 1}</span>
                        <div className="min-w-0">
                          <p className="text-xs font-bold text-slate-700 dark:text-slate-200 truncate">{item.kode_item}</p>
                          <p className="text-[10px] text-slate-400 dark:text-slate-500 truncate">{item.jenis_kategori?.nama_jenis} • {item.berat}gr • {item.karat}krt</p>
                        </div>
                      </div>
                      <button
                        onClick={() => {
                          setSelectedItems(selectedItems.filter((si) => si.id !== item.id));
                          setSelectPindahItems(selectPindahItems.filter((si) => si.id !== item.id));
                        }}
                        className="p-1 text-slate-300 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-all flex-shrink-0 ml-2"
                        title="Hapus dari pilihan"
                      >
                        <IconX size={14} />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="flex items-center gap-2 sm:gap-3 bg-white/90 dark:bg-slate-800/90 backdrop-blur-md rounded-2xl shadow-2xl border border-amber-200/60 dark:border-slate-600/60 px-3 sm:px-5 py-2.5 sm:py-3 w-full overflow-x-auto custom-scrollbar">
              {/* Selection Count - Click to toggle preview */}
              <button
                onClick={() => setShowSelectedPreview(!showSelectedPreview)}
                className="flex items-center gap-1.5 pr-2 sm:pr-3 border-r border-slate-200 dark:border-slate-600 hover:opacity-80 transition-opacity flex-shrink-0"
                title={showSelectedPreview ? 'Tutup daftar' : 'Lihat item dipilih'}
              >
                <span className="bg-amber-500 text-white text-[10px] sm:text-xs font-bold rounded-full w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">{selectedItems.length}</span>
                <span className="text-xs sm:text-sm font-medium text-slate-600 dark:text-slate-300 whitespace-nowrap">item</span>
                {showSelectedPreview ? <IconEyeOff size={14} className="text-slate-400 ml-0.5" /> : <IconEye size={14} className="text-amber-500 ml-0.5" />}
              </button>

              {/* Quick Actions */}
              <div className="flex items-center gap-1 sm:gap-1.5 ml-auto sm:ml-0">
                {(user === 'owner' || user === 'admin' || user === 'supervisor') && (
                    <button
                      type="button"
                      onClick={() => setOpenTransferAntarToko(true)}
                      className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white text-[11px] sm:text-xs font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200 whitespace-nowrap cursor-pointer"
                      title="Kirim / Pindah ke Etalase Toko"
                    >
                      <IconBuildingStore size={14} className="sm:w-4 sm:h-4" />
                      <span className="hidden sm:inline">Pindah Toko</span>
                    </button>
                )}
                {user === 'operator_rumah' && (
                    <button
                      onClick={openModalPindahBarangBanyak}
                      className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-blue-500 hover:bg-blue-600 text-white text-[11px] sm:text-xs font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200 whitespace-nowrap"
                      title="Request Pemindahan ke Brankas Pusat"
                    >
                      <IconTransferOut size={14} className="sm:w-4 sm:h-4" />
                      <span className="hidden sm:inline">Request Pindah</span>
                    </button>
                )}
                {(user === 'admin' || user === 'owner' || user === 'operator_rumah') && (
                    <button
                      onClick={openModalHapusBarangBanyak}
                      className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-red-500 hover:bg-red-600 text-white text-[11px] sm:text-xs font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200 whitespace-nowrap"
                      title="Hapus Barang"
                    >
                      <IconTrash size={14} className="sm:w-4 sm:h-4" />
                      <span className="hidden sm:inline">Hapus</span>
                    </button>
                )}
                {user !== 'admin' && user !== 'supervisor' && (
                    <button
                      onClick={openModalPindahBarangBaki}
                      className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-emerald-500 hover:bg-emerald-600 text-white text-[11px] sm:text-xs font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200 whitespace-nowrap"
                      title="Pindah Baki"
                    >
                      <IconRefresh size={14} className="sm:w-4 h-4" />
                      <span className="hidden sm:inline">Baki</span>
                    </button>
                )}
                <button
                  onClick={openModalPrintBandrol}
                  className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white text-[11px] sm:text-xs font-semibold rounded-xl shadow-sm hover:shadow transition-all duration-200 whitespace-nowrap"
                  title="Print Bandrol"
                >
                  <IconPrinter size={14} className="sm:w-4 sm:h-4" />
                  <span className="hidden sm:inline">Print</span>
                </button>
              </div>

              {/* Clear Selection */}
              <div className="pl-2 sm:pl-3 border-l border-slate-200 dark:border-slate-600 flex-shrink-0">
                <button
                  onClick={() => {
                    setSelectedItems([]);
                    setSelectPindahItems([]);
                    setIsCheckedAll(false);
                    setIsCheckedItems(items.map(() => false));
                    setShowSelectedPreview(false);
                  }}
                  className="p-1.5 sm:p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-xl transition-all duration-200"
                  title="Batal Pilih Semua"
                >
                  <IconX size={14} className="sm:w-4 sm:h-4" />
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ═══ Footer: Summary + Pagination ═══ */}
        <div className="mt-auto sticky bottom-0 left-0 py-2.5 px-4 w-full z-20 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md border-t border-amber-200/60 dark:border-slate-700/60 shadow-[0_-4px_16px_rgba(0,0,0,0.06)] transition-colors">
          <div className="flex items-center justify-between">

            {/* Desktop Summary */}
            <div className="lg:flex hidden items-center gap-5">
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/50 rounded-lg px-3.5 py-2 border border-amber-200/40 dark:border-slate-700">
                <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Modal</span>
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">
                  Rp {numberWithCommas(totalModal === totalModalFilter ? totalModal : totalModalFilter)}
                </span>
              </div>
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/50 rounded-lg px-3.5 py-2 border border-amber-200/40 dark:border-slate-700">
                <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Barang</span>
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBarang}</span>
              </div>
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/50 rounded-lg px-3.5 py-2 border border-amber-200/40 dark:border-slate-700">
                <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Berat</span>
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBerat} gr</span>
              </div>
            </div>

            {/* Mobile Summary */}
            <div className="dropdown dropdown-top lg:hidden">
              <div
                tabIndex={0}
                className="bg-gradient-to-r from-amber-500 to-amber-600 cursor-pointer hover:from-amber-600 hover:to-amber-700 hover:shadow-md p-2 text-white rounded-lg shadow-sm transition-all duration-200"
              >
                <IconListDetails size={20} />
              </div>
              <div tabIndex={0} className="dropdown-content menu p-4 shadow-xl bg-white dark:bg-slate-800 rounded-xl w-[320px] border border-amber-100 dark:border-slate-700">
                <div className="space-y-3">
                  <div className="flex items-center justify-between pb-2.5 border-b border-slate-100 dark:border-slate-700">
                    <span className="text-sm font-semibold text-amber-700 dark:text-amber-400 uppercase">Modal</span>
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-200">
                      Rp {numberWithCommas(totalModal === totalModalFilter ? totalModal : totalModalFilter)}
                    </span>
                  </div>
                  <div className="flex items-center justify-between pb-2.5 border-b border-slate-100 dark:border-slate-700">
                    <span className="text-sm font-semibold text-amber-700 dark:text-amber-400 uppercase">Total Barang</span>
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBarang} barang</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold text-amber-700 dark:text-amber-400 uppercase">Total Berat</span>
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{jmlBerat} gram</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Pagination & Per Page Selector */}
            <div className="flex items-center gap-3 sm:gap-4 flex-wrap">
              {/* Tampilkan [ 50 v ] data per halaman */}
              <div className="flex items-center gap-1.5 text-xs sm:text-sm text-slate-500 dark:text-slate-400">
                <span>Tampilkan</span>
                <select
                  value={itemsPerPage || 10}
                  onChange={(e) => {
                    const newPerPage = Number(e.target.value);
                    setItemsPerPage(newPerPage);
                    setCurrentPage(1);
                  }}
                  className="h-8 px-2 border border-slate-200 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 font-bold text-xs sm:text-sm focus:border-amber-400 focus:ring-1 focus:ring-amber-200 outline-none transition-all cursor-pointer shadow-xs"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <span className="hidden sm:inline">data per halaman</span>
              </div>

              {/* Pagination */}
              <div className="flex items-center gap-2.5">
                <span className="text-xs font-medium text-slate-500 dark:text-slate-400 flex items-center gap-1.5">
                  Halaman
                  <input
                    type="text"
                    value={pageInput}
                    onChange={handlePageInputChange}
                    onBlur={jumpToPage}
                    onKeyDown={handlePageInputKeyDown}
                    className="w-12 h-7 text-center border border-slate-200 dark:border-slate-600 rounded-md bg-white dark:bg-slate-800 text-amber-700 dark:text-amber-400 font-bold focus:border-amber-400 focus:ring-1 focus:ring-amber-200 outline-none transition-all"
                  />
                  dari <span className="font-bold text-amber-700 dark:text-amber-400">{page}</span>
                </span>
                <div className="flex items-center gap-1">
                  <button
                    onClick={prevPage}
                    disabled={currentPage < 2}
                    title="previous"
                    type="button"
                    className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                  >
                    <IconChevronLeft size={16} />
                  </button>
                  <button
                    onClick={nextPage}
                    disabled={currentPage >= page}
                    title="next"
                    type="button"
                    className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                  >
                    <IconChevronRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
    </>
  );
}

export default ListBrankas;
